/**
 * An immutable "set" of items.
 */
export type ItemsSet<T, K extends string = string> = { readonly [key in K]?: Readonly<T> };
export type MutableItemsSet<T, K extends string = string> = {[key in K]?: Readonly<T> };

/**
 * A "set" of keys; membership in the set is defined by the key's existence.
 */
export type KeySet<K extends string = string> = ItemsSet<true, K>;
export type MutableKeySet<K extends string = string> = MutableItemsSet<true, K>;

export function addStringListToKeySet(keySet: MutableKeySet, list: ReadonlyArray<string>): void {
  for (const value of list) {
    keySet[value] = true;
  }
}

export function stringListToKeySet(list: ReadonlyArray<string> | null | undefined): KeySet {
  const keySet: MutableKeySet = {};
  if (list) {
    addStringListToKeySet(keySet, list);
  }
  return keySet;
}

export function keySetToStringList(keys: KeySet): ReadonlyArray<string> {
  const list: string[] = [];
  for (const key in keys) {
    if (keys.hasOwnProperty(key)) {
      list.push(key);
    }
  }
  return list;
}

export function getKeySetSize(keys: KeySet): number {
  let size = 0;
  for (const key in keys) {
    if (keys.hasOwnProperty(key)) {
      size++;
    }
  }
  return size;
}
